import { inject, provideEnvironmentInitializer } from '@angular/core';
import { SOFTLINE_CONFIG_LAGERPLATZ_UMLAGERUNG } from '@softapps/lager/lagerplatz-umlagerung';
import {
  provideDarkTheme,
  SOFTLINE_CONFIG_DEFAULT_THEME,
  SOFTLINE_CONFIG_THEMES,
} from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { CustomerConfig } from 'apps/softapps/src/customer-config.type';

const de = {
  '#KOMMISSIONIERUNG': {
    PAGES: {
      AUFTRAG_AUSWAHL: {
        LAGERPLATZ_AUSWAHL: 'Innenlager',
        KEINE_LAGERPLATZ_AUSWAHL: 'Aussenlager',
      },
      FILTER: {
        LAGERPLATZ_AUSWAHL: {
          TITLE: 'Lager',
          NONE: 'Alle',
          JA: 'Innenlager',
          NEIN: 'Aussenlager',
        },
      },
    },
  },
};

export const customerConfig: CustomerConfig = {
  version: '0.0.0',
  id: 'at.softline.lagerhaus.innviertel.softline',
  name: 'Lagerhaus Innviertel-Traunviertel Softline',
  providers: [
    { provide: SOFTLINE_CONFIG_DEFAULT_THEME, useValue: 'lagerhaus' },
    provideDarkTheme(false),
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'lagerhaus',
        name: 'Lagerhaus',
      },
      multi: true,
    },
    { provide: SOFTLINE_CONFIG_LAGERPLATZ_UMLAGERUNG, useValue: { artehEingabe: false } },
    provideEnvironmentInitializer(() => {
      inject(Store).commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
        module: 'lagerhausInnviertel',
        language: 'de',
        translations: de,
        priority: 1,
      });
    }),
  ],
};
